import { EAvailableLanguages } from '@/configuration/lang/types';

import { onboardingMessagesDE } from '../../mocks/onBoarding/de';
import { onboardingMessagesEN } from '../../mocks/onBoarding/en';
import { onboardingMessagesFR } from '../../mocks/onBoarding/fr';

export function useOnboardingMessages(language: string) {
  const messagesMap: Record<EAvailableLanguages, typeof onboardingMessagesEN> = {
    [EAvailableLanguages.DE]: onboardingMessagesDE,
    [EAvailableLanguages.FR]: onboardingMessagesFR,
    [EAvailableLanguages.EN]: onboardingMessagesEN,
  };

  if (Object.values(EAvailableLanguages).includes(language as EAvailableLanguages)) {
    return messagesMap[language as EAvailableLanguages];
  }

  return onboardingMessagesEN;
}
